import { ContentTag } from "scrivito"
import { BuildingReferencesOverviewPageObj } from "scrivito/Objs/BuildingReferencesOverviewPage/BuildingReferencesOverviewPageObjClass"
import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import "./styles/_building-references-overview-page.scss"

interface BuildingReferencesOverviewPageProps {
  page: BuildingReferencesOverviewPageObj
}

export function BuildingReferencesOverviewPage({
  page
}: BuildingReferencesOverviewPageProps) {
  useScrivitoPage()
  useScrollController()

  return (
    <ContentTag
      className="building-references-overview-page"
      content={page}
      attribute="body"
    />
  )
}
